// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { createResponseObj } from '..'
import { vcBaseUrl } from '.'


type RehydrateSessionResponse = (SuccessResponse & {
    status: string
    token: string
}) | FailedResponse

export class RehydrateSessionRequest extends Request {
    private constructor(init?: RequestInit) { super(`${vcBaseUrl}/session/rehydrate`, init) }
    static async init(body: {}, init?: RequestInit) {
        return new RehydrateSessionRequest({
            ...init,
            method: 'POST',
            credentials: "include",
            body: JSON.stringify(body),
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<SuccessResponse & { status: string; token: string; }> {
        const response = await fetch(this)
        const data = createResponseObj<RehydrateSessionResponse>(await response.json())
        console.info("Revoke Session Results:", data)
    
        switch (data.status) {
            case 'successful': return data
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}